import { show } from 'js-snackbar';
import 'js-snackbar/snackbar.css';

export class Toast {
	static info(message: string, duration: number = 3000, position: string = 'top-right') {
		show({ text: message, duration: duration, pos: position, customClass: 'bg-info' });
	}
	static error(message: string, duration: number = 3000, position: string = 'top-right') {
		show({ text: message, duration: duration, pos: position, customClass: 'bg-danger text-white' });
	}
	static warning(message: string, duration: number = 3000, position: string = 'top-right') {
		show({ text: message, duration: duration, pos: position, customClass: 'bg-warning' });
	}
}